import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { loadStripe } from "@stripe/stripe-js";
import { ApiService } from "src/app/shared/services/api.service";

@Component({
  selector: "app-domain-selection",
  standalone: false,
  // imports:[CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: "./domain-selection.component.html",
  styleUrl: "./domain-selection.component.css",
})
export class DomainSelectionComponent {
  @Input() selectedDomain: string = "";
  @Output() selectedDomainChange = new EventEmitter<string>();
  @Output() next = new EventEmitter<void>();

  ngOnChanges() {
    this.selectedDomainChange.emit(this.selectedDomain);
  }
  monthOptions: number[] = Array.from({ length: 22 }, (_, i = 0) => i + 3); // [1, 2, ..., 24]

  // domains = ["Road", "Commercial", "Education", "Utilities", "Consultancy"];
  selectedDomains: string[] = [];
  domains = [
    // { name: 'Commercial', price: 1.5, unit: 'per sq.m.', description: 'Shops & malls' },
    // { name: 'Education', price: 1.5, unit: 'per sq.m.', description: 'Schools & colleges' },
    // { name: 'Residential', price: 1.5, unit: 'per sq.m.', description: 'Home' },
    // { name: 'Utilities', price: 4.5, unit: 'per sq.m.', description: 'Water & electricity' },
    // { name: 'Water', price: 1.5, unit: 'per sq.m.', description: 'Water' },
    // { name: 'Telecom', price: 1.5, unit: 'per sq.m.', description: 'Telecom' },
    // { name: 'Electric', price: 1.5, unit: 'per sq.m.', description: 'Water' },
    // { name: 'Gas', price: 1.5, unit: 'per sq.m.', description: 'Gas' },
    { name: 'Consultancy', price: 1000, unit: 'per project', description: 'Expert-based analysis' },
  { name: 'Road', price: 1.5, unit: 'per km', description: '' },
  { name: 'Construction', price: 1.5, unit: 'per sq.m.', description: 'Shops & malls' },
  { name: 'Utilities', price: 4.5, unit: 'per sq.m.', description: 'Water & electricity' },
    ];

  form: FormGroup;
  totalAmount = 0;
  subtotal = 0;
  gstAmount = 0;
  orderTotal = 0;
  paymentGateway: 'stripe' | 'razorpay' = 'razorpay';
  loading = false;

  headerLogo: string | undefined = "../../assets/image/logo.png";
  supportContactEmail: string | undefined = "support@sigmat.in";
  supportContactNumber: string | undefined = "+91 4442624172";


  constructor(private fb: FormBuilder, private apiService: ApiService, private paymentService: ApiService) {
    const userData = JSON.parse(localStorage.getItem("user") || '{}');
    this.selectedDomains = userData.user?.domain?.split(",") || [];
    console.log(this.selectedDomains)
    this.form = this.fb.group({
      organization_id: [userData.user?.branch_id || userData.user?.org_id],
      organization_code: [userData.user?.branch_code || userData.user?.company_code],
      duration: [0],
      total_amount: 0,
      users_count: [0],
      consultancy_projects: [0],
      Road: this.fb.group({
        // length: [0],
        // lanes: [1],
        users_count: [0]
      }),
      Construction: this.fb.group({
        // area: [0],
        users_count: [0],
      }),
      // Education: this.fb.group({
      //   area: [0],
      //   users_count: [0],
      // }),
      Utilities: this.fb.group({
        // length: [0],
        users_count: [0],
      }),
      // Water: this.fb.group({
      //   length: [0],
      //   users_count: [0],
      // }),
      // Telecom: this.fb.group({
      //   length: [0],
      //   users_count: [0],
      // }),
      // Electric: this.fb.group({
      //   length: [0],
      //   users_count: [0],
      // }),
      // Gas: this.fb.group({
      //   length: [0],
      //   users_count: [0],
      // }),
      Consultancy: this.fb.group({
        // projects: [0],
        users_count: [0],
      }),
    });
  }


  calculateTotal(): void {
    const value = this.form.value;
    this.apiService.calculateSubscriptionFee({
      duration: value.duration,
      Road: this.selectedDomains.includes('Road') ? value.Road : { users_count: 0 },
      Construction: this.selectedDomains.includes('Construction') ? value.Construction : { users_count: 0 },
      Utilities: this.selectedDomains.includes('Utilities') ? value.Utilities : { users_count: 0 },
      Consultancy: this.selectedDomains.includes('Consultancy') ? value.Consultancy : { users_count: 0 },
    }).subscribe({
      next: (res: any) => {
        const data = res?.data || {};
        this.subtotal = data.subtotal || 0;
        this.gstAmount = data.gstAmount || 0;
        this.orderTotal = data.total || 0;
        this.totalAmount = this.orderTotal;
        this.form.patchValue({ total_amount: this.orderTotal });
      },
      error: () => {
        let total = 0;
        if (this.selectedDomains.includes('Road')) total += (value.Road?.users_count || 0) * 400;
        if (this.selectedDomains.includes('Construction')) total += (value.Construction?.users_count || 0) * 400;
        if (this.selectedDomains.includes('Utilities')) total += (value.Utilities?.users_count || 0) * 400;
        if (this.selectedDomains.includes('Consultancy')) total += (value.Consultancy?.users_count || 0) * 400;
        this.subtotal = Math.round(total) * (value.duration || 1);
        this.gstAmount = Math.round(this.subtotal * 0.18);
        this.orderTotal = this.subtotal + this.gstAmount;
        this.totalAmount = this.orderTotal;
        this.form.patchValue({ total_amount: this.orderTotal });
      }
    });
  }
  calculateTotalOld(): void {
    const value = this.form.value;
    let total = 0;

    // Base User + Consultancy Costs
    // total += value.users_count * this.form.value.duration * 400;
    // total += value.consultancy_projects * 1000;

    // Road
    if (this.selectedDomains.includes("Road")) {
      const { length, lanes, users_count } = value.Road;
      const area = length * lanes * 1000 * 3.5; // Convert km to meters → 3500 sq.m/lane/km
      total += ((area * 1.5) + (users_count * 400));
    }

    // Commercial
    if (this.selectedDomains.includes("Commercial")) {
      total += (value.Commercial.area * 1.5) + (value.Commercial.users_count * 400);
    }

    // Education
    if (this.selectedDomains.includes("Education")) {
      total += ((value.Education.area * 1.5) + (value.Education.users_count));
    }

    // Utilities
    // if (this.selectedDomains.includes("Utilities")) {
    //   total += (value.Utilities.length * 4.5) + (value.Utilities.users_count*400);
    // }
    //
    if (this.selectedDomains.includes("Water")) {
      total += (value.Water.length * 4.5) + (value.Water.users_count * 400);
    }
    if (this.selectedDomains.includes("Telecom")) {
      total += (value.Telecom.length * 4.5) + (value.Telecom.users_count * 400);
    }
    if (this.selectedDomains.includes("Electric")) {
      total += (value.Electric.length * 4.5) + (value.Electric.users_count * 400);
    }
    if (this.selectedDomains.includes("Gas")) {
      total += (value.Gas.length * 4.5) + (value.Gas.users_count * 400);
    }

    // Consultancy
    if (this.selectedDomains.includes("Consultancy")) {

      total += ((value.Consultancy.projects * 1000) + (value.Consultancy.users_count * 400));
    }

    this.totalAmount = Math.round(total) * this.form.value.duration;
    console.log(this.totalAmount)
    this.form.patchValue({ total_amount: total });
  }
  onDomainChange(event: any): void {
    const domain = event.target.value;
    if (event.target.checked) {
      this.selectedDomains.push(domain);
    } else {
      this.selectedDomains = this.selectedDomains.filter((d) => d !== domain);
    }
    this.calculateTotal();
  }

  proceedToPay() {
    if (this.orderTotal === 0) {
      return;
    }

    this.loading = true;
    const formData = this.form.value;
    console.log(formData);
    
    this.apiService.createSubscription(formData)
      .subscribe((res: any) => {
        console.log(res);
        if (res) {
          if (this.paymentGateway === 'razorpay') {
            this.subscribeWithRazorpay();
          } else {
            this.subscribeWithStripe();
          }
        } else {
          this.loading = false;
        }
      }, (error) => {
        console.error('Error creating subscription:', error);
        this.loading = false;
      });
  }

  async subscribeWithStripe() {
    this.paymentService.subscribeToPackage(this.form.value).subscribe({
      next: async (response) => {
        console.log('Subscription successful', response);
        const clientSecret = response.clientSecret;

        const stripe = await loadStripe('pk_test_51P01nISHroK2oGqaxpHGQ3hpY2fyN32twitKHJijxBGQI9grqg0FTBlfQo8jbcTa2zLwvrUMnkMrfHeoDh3QPea100xOLMxzEu');
        if (stripe) {
          await stripe.redirectToCheckout({
            sessionId: clientSecret
          });
        } else {
          console.error('Stripe failed to initialize.');
          this.loading = false;
        }
      },
      error: (error) => {
        console.error('Subscription failed', error);
        this.loading = false;
      }
    });
  }

  subscribeWithRazorpay() {
    const formData = this.form.value;
    
    this.apiService.createSubscriptionRazorpayOrder({
      amount: this.orderTotal,
      currency: 'INR',
      subscription_data: formData
    }).subscribe({
      next: (response: any) => {
        if (response.success && response.data) {
          const options = {
            key: response.data.key,
            amount: response.data.amount,
            currency: response.data.currency,
            name: 'SigmaTConflux Subscription',
            description: 'Portal Subscription Fee',
            order_id: response.data.orderId,
            handler: (paymentResponse: any) => {
              this.verifyRazorpayPayment(paymentResponse, response.data.subscriptionId);
            },
            prefill: {
              name: '',
              email: '',
              contact: ''
            },
            theme: {
              color: '#3399cc'
            },
            modal: {
              ondismiss: () => {
                this.loading = false;
                console.log('Payment cancelled');
              }
            }
          };

          const razorpayInstance = new (window as any).Razorpay(options);
          razorpayInstance.open();
        } else {
          this.loading = false;
          console.error('Failed to create Razorpay order');
        }
      },
      error: (error: any) => {
        console.error('Error creating Razorpay order:', error);
        this.loading = false;
      }
    });
  }

  verifyRazorpayPayment(paymentResponse: any, subscriptionId: number) {
    this.apiService.verifySubscriptionRazorpayPayment(subscriptionId, {
      razorpay_order_id: paymentResponse.razorpay_order_id,
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      razorpay_signature: paymentResponse.razorpay_signature
    }).subscribe({
      next: (response: any) => {
        if (response.success) {
          console.log('Payment verified successfully');
          // Redirect to success page with payment_id and subscription_id
          window.location.href = `/home/success?payment_id=${paymentResponse.razorpay_payment_id}&subscription_id=${subscriptionId}`;
        } else {
          this.loading = false;
          console.error('Payment verification failed');
        }
      },
      error: (error: any) => {
        console.error('Error verifying payment:', error);
        this.loading = false;
      }
    });
  }

}
